import React, { useContext } from "react";
import { connect } from "react-redux";
import { Box } from "@material-ui/core";
import Col from "../../../UIcomponent/Column";
import StyledButton from "../../../UIcomponent/Button";
import LocalContext from "../../../Context/LocalContetxt";
import DashboradTitle from "../DashboradTitle/DashboradTitle";
import DashboardListItem from "../../Dashboard/DashboardListItem/DashboardListItem";
import StyledLink from "../../../UIcomponent/Link";
import NoItemFound from "../../../Component/NoItemFound";
import { RoutePath } from "../../../Utility/RoutePath";
import SkeletonLoader from "../../../UIcomponent/SkeletonLoader";
import Filter from "./components/Filter";
import "./LessonsList.scss";
import { useLocation } from "react-router-dom";

const LessonsList = (props) => {
  const { theme, data, noMore, loading, setTab } = props;
  const lang = useContext(LocalContext).lang;
  const config = useContext(LocalContext).config;
  const location = useLocation();

  const renderContent = () => {
    if (loading && data.length <= 0) {
      return Array(6)
        .fill([])
        .map((item) => <SkeletonLoader />);
    }
    if (config && config.role && data.length !== 0) {
      return data.map((each) => {
        return (
          <DashboardListItem
            theme={theme}
            lang={lang}
            data={each}
            loading={loading}
            role={config.role}
          />
        );
      });
    }

    return null;
  };

  return (
    <>
      <Col xl={24} lg={24} md={24} sm={24} xs={24} className="l__LessonsList">
        <DashboradTitle title="کلاس‌های من" />

        <Col className="c__LessonsList" xl={24} lg={24} md={24} sm={24} xs={24}>
          {location.pathname === "/lessons" ? <Filter /> : null}
          {renderContent()}
        </Col>

        <Box mt="50px">
          <NoItemFound
            desc="کلاسی برای نمایش وجود ندارد."
            visible={data.length === 0 && !loading}
            noAction
          />
        </Box>
        <Col
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          className="c__LessonsList__Button"
        >
          {!noMore && (
            <StyledButton
              default
              width="170px"
              hoverBackgroundColor={theme.primary}
            >
              <StyledLink
                width="100%"
                height="100%"
                active={true}
                hoverColor={theme.white}
                to={RoutePath.lessons}
              >
                مشاهده همه کلاس ها
              </StyledLink>
            </StyledButton>
          )}
        </Col>
      </Col>
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.dashboard.sessions.fetching,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LessonsList);
